import { Footer as FooterComponent } from 'app/components/Common/Footer'
import { graphql, StaticQuery } from 'gatsby'
import React, { memo } from 'react'

import { getFooterProps } from './getFooterProps'

export interface Props {
  languageCode: string
  languagePrefix?: string | null
}

export const Footer = memo(function Footer({
  languageCode,
  languagePrefix,
}: Props) {
  return (
    <StaticQuery
      query={graphql`
        query FooterData {
          site {
            siteMetadata {
              title
            }
          }
          logo: allFile(filter: { name: { eq: "logo" } }) {
            nodes {
              publicURL
            }
          }
          cms {
            company {
              address
              cin
              country
              email
              facebook
              fax
              instagram
              link_footer_label
              link_footer_url
              locality
              phone
              postal_code
              region
              vat
              ibeid
              whatsapp
            }
          }
        }
      `}
      render={(data) => {
        const props = getFooterProps(data, languageCode)

        return props ? (
          <FooterComponent languagePrefix={languagePrefix} {...props} />
        ) : null
      }}
    />
  )
})
